import React from 'react';
import { Pagination } from '../../Pagination/Pagination';

interface IFlexColumnListFooterProps {
  currentPage: number;
  currentPageSize: number;
  amountOfPages: number;
  totalAmount: number;
  pageSize: number;
  loading?: boolean;
  changePageSize?: (pageSize: number) => void;
  changePage?: (page: number) => void;
}

export const FlexColumnListFooter: React.FC<IFlexColumnListFooterProps> = ({
  currentPage,
  currentPageSize,
  amountOfPages,
  totalAmount,
  pageSize,
  loading,
  changePageSize,
  changePage
}) => {

  return (
    <Pagination
      data-class='FlexColumnListFooter_Pagination'
      currentPage={currentPage}
      currentPageSize={currentPageSize}
      amountOfPages={amountOfPages}
      totalAmount={totalAmount}
      pageSize={pageSize}
      changePageSize={(size) => changePageSize && changePageSize(size)}
      changePage={(page) => changePage && changePage(page)}
      backgroundColor='#fff'
      padding='0px'
      filtering={loading}
    />
  );
}